module.exports = __webpack_public_path__ + "img/single.8ae8e567.png";